import {otsBaseApi} from "../../ots-api";
import {CompanyUnit} from "../../../model/company-unit";
import { removeUndefined } from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["CompanyUnits", "CompanyCompanyUnits"]});

const containerClusterApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCompanyUnits: builder.query<CompanyUnit[], string | undefined>({
      query: (regionId) => ({
        url: `/company-units/all`,
        method: "GET",
        params: removeUndefined({
          regionId
        })
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "CompanyUnits", id} as const)),
            {type: "CompanyUnits", id: "LIST"}
          ];
        } else {
          return [{type: "CompanyUnits", id: "LIST"}];
        }
      }
    }),
    getCompanyUnitsByCompany: builder.query<
      CompanyUnit[],
      { companyId: string, regionId?: string }
    >({
      query: ({companyId, regionId}) => ({
        url: `/company-units/company/${companyId}`,
        method: "GET",
        params: removeUndefined({
          regionId
        })
      }),
      providesTags: (result, _error, arg, _meta) => {
        if (result) {
          return [
            ...result.map(
              ({id}) => ({type: "CompanyUnits", id} as const)
            ),
            {type: "CompanyCompanyUnits", id: arg.companyId}
          ];
        } else {
          return [];
        }
      }
    }),
    getCompanyUnit: builder.query<CompanyUnit, string>({
      query: (id) => ({
        url: `/company-units/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "CompanyUnits", id}]
    }),
    createCompanyUnit: builder.mutation<CompanyUnit, Partial<CompanyUnit>>({
      query: (mapping) => ({
        url: "/company-units",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "CompanyUnits", id: "LIST"}]
    }),
    updateCompanyUnit: builder.mutation<CompanyUnit, Partial<CompanyUnit>>({
      query: (mapping) => ({
        url: "/company-units",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "CompanyUnits", id}]
    }),
    deleteCompanyUnit: builder.mutation<void, Partial<CompanyUnit>>({
      query: (mapping) => ({
        url: "/company-units",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "CompanyUnits", id}]
    }),
  })
});

export const {
  useGetAllCompanyUnitsQuery,
  useGetCompanyUnitsByCompanyQuery,
  useGetCompanyUnitQuery,
  useCreateCompanyUnitMutation,
  useUpdateCompanyUnitMutation,
  useDeleteCompanyUnitMutation,
} = containerClusterApi;
